"use client";
import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { withCmsDataHandling as C } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import N from "../../layout/Container/Container.js";
import { useTheme as H, Group as r, Paragraph as n, Image as x, Heading as g, TextLink as f, rem as P, Divider as y, sharedHandler as b } from "@ingeniorforeningen/figurine-core";
import { forwardRef as B } from "react";
import { ConditionBoxDeliveryApiParser as G } from "./ConditionBox.helpers.js";
import '../../../assets/ConditionBox.css';const T = "_item_1yxxu_2", z = "_middleGroup_1yxxu_6", D = "_groupHeader_1yxxu_12", j = "_divier_1yxxu_16", A = "_partner_1yxxu_21", a = {
  item: T,
  middleGroup: z,
  groupHeader: D,
  divier: j,
  partner: A
}, c = B((_, v) => {
  const { header: m, text: p, teaser: l, image: u, partner: o, links: s, ...w } = _, h = H();
  return /* @__PURE__ */ i(N, { ...w, size: "md", ref: v, children: [
    /* @__PURE__ */ i(r, { direction: "column", spacing: "md", pb: 0, hiddenFrom: "sm", children: [
      /* @__PURE__ */ e(n, { text: l, variant: "primary", medium: !0, transform: "uppercase", scale: 0.875 }),
      /* @__PURE__ */ i(r, { align: "center", spacing: "sm", wrap: "nowrap", children: [
        /* @__PURE__ */ e(
          x,
          {
            ...u,
            caption: void 0,
            byline: void 0,
            width: 70,
            height: 70,
            shadow: !0,
            sizes: "70px"
          }
        ),
        /* @__PURE__ */ e(g, { type: "h3", text: m })
      ] }),
      /* @__PURE__ */ e(n, { text: p }),
      /* @__PURE__ */ e(r, { direction: "column", spacing: 0, children: s.map((t, d) => /* @__PURE__ */ e(
        f,
        {
          variant: "component",
          icon: t.icon,
          iconPlacement: "left",
          text: t.text,
          href: t.href,
          target: t.target,
          scale: 0.875
        },
        d
      )) }),
      o && /* @__PURE__ */ i(r, { spacing: P("6.4px"), children: [
        /* @__PURE__ */ e(n, { text: "Partner:", strong: !0, scale: 0.875 }),
        /* @__PURE__ */ e(n, { text: o, scale: 0.875 })
      ] })
    ] }),
    /* @__PURE__ */ i(r, { align: "center", spacing: 0, pb: 0, className: a.item, visibleFrom: "sm", children: [
      /* @__PURE__ */ e(
        x,
        {
          ...u,
          caption: void 0,
          byline: void 0,
          width: 120,
          height: 168,
          shadow: !0,
          sizes: "120px"
        }
      ),
      /* @__PURE__ */ i(r, { direction: "column", spacing: 0, pl: "xl", className: a.middleGroup, children: [
        /* @__PURE__ */ e(n, { text: l, variant: "primary", medium: !0, transform: "uppercase" }),
        /* @__PURE__ */ i(r, { direction: "column", spacing: 0, children: [
          /* @__PURE__ */ e(g, { type: "h2", text: m, className: a.groupHeader }),
          /* @__PURE__ */ e(n, { text: p })
        ] }),
        /* @__PURE__ */ e(r, { spacing: 0, wrap: "nowrap", children: s.map((t, d) => /* @__PURE__ */ i(r, { spacing: 0, wrap: "nowrap", children: [
          /* @__PURE__ */ e(
            f,
            {
              weight: 600,
              icon: t.icon,
              iconPlacement: "left",
              text: t.text,
              href: t.href,
              target: t.target,
              scale: 0.875,
              condensed: !0
            }
          ),
          d !== s.length - 1 && /* @__PURE__ */ e(
            y,
            {
              mx: "md",
              orientation: "vertical",
              className: a.divider,
              color: h.other?.colorTokens.dividers.dark
            }
          )
        ] }, d)) })
      ] }),
      o && /* @__PURE__ */ i(r, { direction: "column", className: a.partner, children: [
        /* @__PURE__ */ e(n, { text: "Partner:", align: "right", strong: !0 }),
        /* @__PURE__ */ e(n, { text: o, align: "right", condensed: !0 })
      ] })
    ] }),
    /* @__PURE__ */ e(y, { mt: "xl", color: h.other?.colorTokens.dividers.dark })
  ] });
});
c.displayName = "ConditionBox";
const F = C({
  Component: b(c),
  deliveryApiParser: G
});
F.displayName = c.displayName;
export {
  a as C,
  c as _ConditionBox,
  F as default
};
